import { FC } from "react"
import { useMobReward } from "@/hooks/useMobReward"
import { MobRewardView } from "@/modals/constructor/mobs/MobRewardModal/ui"
import { useModal } from "@/modals/hooks"
import { Modal } from "@/ui/Modal"
import styles from "./MobRewardModal.module.scss"

const modalType = "mobReward"

export const MobRewardModal: FC = () => {
  const { modal, getModalParams } = useModal(modalType)
  const { killId } = getModalParams(modalType)
  const view = useMobReward(killId)

  return (
    <Modal.Center type={modalType} isCanClose={false} className={styles.raise}>
      <MobRewardView {...view} onOk={modal.close} />
    </Modal.Center>
  )
}
